/**
 * AccountWebhooks API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createAccountWebhook,
  deleteAccountWebhook,
  getAccountWebhookById,
  getAccountWebhooks,
  rotateAccountWebhookSecret,
  testAccountWebhook,
  updateAccountWebhook,
} from "../generated/account-webhooks/account-webhooks";

import { wrapListMethod, wrapMethod } from "./utils";

export const accountWebhooks = {
  /** @see createAccountWebhook */
  create: wrapMethod(createAccountWebhook),

  /** @see getAccountWebhooks */
  list: wrapListMethod(getAccountWebhooks),

  /** @see getAccountWebhookById */
  get: wrapMethod(getAccountWebhookById),

  /** @see updateAccountWebhook */
  update: wrapMethod(updateAccountWebhook),

  /** @see deleteAccountWebhook */
  delete: wrapMethod(deleteAccountWebhook),

  /** @see testAccountWebhook */
  testAccountWebhook: wrapMethod(testAccountWebhook),

  /** @see rotateAccountWebhookSecret */
  rotateAccountWebhookSecret: wrapMethod(rotateAccountWebhookSecret),
} as const;

export type AccountWebhooksApi = typeof accountWebhooks;
